import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography, Button, Box, Grid, TextField, Dialog } from "@material-ui/core";
import useMediaQuery from '@mui/material/useMediaQuery';
import useIsDesktop from "../hooks/useIsDesktop";
import { styled } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { grey } from "@mui/material/colors";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";
import defaultimg from "../assets/images/default.png";
import AddItemButton from "../components/AddItemButton";
import { BUTTON_COLOR, TEXT_COLOR } from "../utils/constant";
const StyledButton = styled(Button)({
  textTransform: "none",
  boxShadow: "none",
  borderRadius: "8px",
  padding: "10px 16px",
  fontWeight: 600,
});

const TentPopup = function (props) {
  const { openTent, setOpenTent, storeInfoConfig } = props;

  const sessionReducer = useSelector(state => state.sessionReducer) || {};
  const reduxConfig = sessionReducer.store_config || storeInfoConfig || props.sessionReducer?.store_config || {};
  let primaryColor = reduxConfig?.general_config?.primary_color;
  let secondaryColor = storeInfoConfig?.general_config?.secondary_color;

  const [tentno, setTentno] = useState("");
  const [errMsg, setErrMsg] = useState(false);
  const dispatch = useDispatch();
  const isDesktop = useIsDesktop();

  const isMenuOnly = reduxConfig?.web_ordering_setting?.is_menu === true || sessionReducer?.store_config?.web_ordering_setting?.is_menu === true;

  useEffect(() => {
    if (openTent && !isMenuOnly) {
      setTentno(sessionReducer?.tent_id || "");
    }
  }, [openTent, sessionReducer?.tent_id, isMenuOnly]);

  const toggleDrawer = (newOpen) => (event, reason) => {
    // Prevent closing via backdrop click, escape, or swipe down
    if (!newOpen) {
      return;
    }
  };

  if (isMenuOnly) {
    return null;
  }

  return (
    <>
      <CssBaseline />
      <style>{`
        input[type=number]::-webkit-inner-spin-button, 
        input[type=number]::-webkit-outer-spin-button { 
          -webkit-appearance: none; 
          margin: 0; 
        }
        input[type=number] {
          -moz-appearance: textfield;
        }
      `}</style>
      {isDesktop ? (
        <Dialog
          open={openTent}
          onClose={() => {}}
          disableEscapeKeyDown
          PaperProps={{
            style: {
              borderRadius: "16px",
              width: "420px",
              padding: "24px",
              boxShadow: "0px 10px 32px -4px rgba(20, 10, 5, 0.18), 0px 2px 6px 0px rgba(0, 0, 0, 0.07)",
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 3,
            }}
          >
            <Typography variant="h6">
              <span style={{ fontWeight: "700", fontFamily: "satoshi", fontSize: "20px" }}>
                Enter Table/Tent Number
              </span>
            </Typography>
          </Box>
          <Box display="flex" flexDirection="column" style={{ gap: "16px" }}>
            <TextField
              size="small"
              style={{
                width: "100%",
                border: "1px solid #E5E7EB",
                borderRadius: "8px",
                backgroundColor: "#F9FAFB"
              }}
              InputProps={{
                disableUnderline: true,
                style: { padding: "10px 14px" },
              }}
              inputProps={{
                style: {
                  fontWeight: 600,
                  fontSize: "16px",
                },
                "& input::placeholder": {
                  fontWeight: 500,
                  color: "#9CA3AF"
                },
              }}
              type="number"
              onInput={(e) => {
                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 10);
              }}
              onChange={(e) => {
                setTentno(e.target.value);
                if (e.target.value) setErrMsg(false);
              }}
              value={tentno}
              placeholder="Enter Tent Number"
            />
            {errMsg && (
              <Typography style={{ color: "#EF4444", fontSize: "14px", fontWeight: 500, marginTop: "-8px" }}>
                Please enter a valid tent number
              </Typography>
            )}
            <Button
              fullWidth
              variant="contained"
              disableElevation
              onClick={() => {
                if (!tentno || !tentno.trim() || parseInt(tentno, 10) === 0) {
                  setErrMsg(true);
                } else {
                  dispatch({
                    type: 'WEB_LOGIN',
                    payload: {
                      ...sessionReducer,
                      table_details: {},
                      tent_id: tentno.trim()
                    }
                  });
                  setOpenTent(false);
                  setErrMsg(false);
                }
              }}
              style={{
                fontSize: "16px",
                fontWeight: 700,
                padding: "12px",
                borderRadius: "8px",
                textTransform: "none",
                color: "white",
                backgroundColor: primaryColor || BUTTON_COLOR,
                marginTop: "8px"
              }}
            >
              Continue
            </Button>
          </Box>
        </Dialog>
      ) : (
      <Drawer
        anchor="bottom"
        open={openTent}
        onClose={toggleDrawer(false)}
        PaperProps={{
          style: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            maxHeight: "90%",
          },
        }}
      >
        <Box sx={{ overflow: "auto", maxHeight: "calc(100% - 50px)" }}>
          {/* Header */}
          <Box
            sx={{
              p: 2,
              pt: 2,
              pb: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 3,
              marginBottom: "5px",
              backgroundColor: "white",
              padding: "10px 16px ",
              boxShadow: " rgba(0, 0, 0, 0.08) 0px 2px 12px",
            }}
          >
            <Typography variant="h6">
              <span style={{ fontWeight: "600", fontFamily: "satoshi" }}>
                Enter Table/Tent Number
              </span>
            </Typography>
          </Box>

          {/* Customized items list */}
          <Box display="flex" justifyContent="center" position="relative">
            <TextField
              size="small"
              style={{
                width: "90%",
                margin: "1rem",

                border: "1px solid #ccc",
                borderRadius: "8px",
              }}
              InputProps={{
                disableUnderline: true,
                style: { padding: "10px" },
              }}
              inputProps={{
                style: {
                  fontWeight: 600,
                  fontSize: "16px",
                },
                "& input::placeholder": {
                  fontWeight: 400,
                  opacity: 1,
                },
              }}
              type="number"
              onInput={(e) => {
                e.target.value = Math.max(0, parseInt(e.target.value))
                  .toString()
                  .slice(0, 10);
              }}
              onChange={(e) => {
                setTentno(e.target.value);
              }}
              value={tentno}
              placeholder="Enter table/tent number"
            />
            {/* {custMoile && ( */}
            <button
              style={{
                position: "absolute",
                right: "6%",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
              onClick={() => setTentno("")}
            >
              <CloseIcon />
            </button>
            {/* )} */}
          </Box>
        </Box>

        <div
          style={{
            minWidth: "100%",
            display: "flex",
            marginTop: "-0.5rem",
            marginBottom: "0.5rem",
            padding: "0px 2rem",
          }}
        >
          {errMsg && (
            <span style={{ color: "red" }}>Please enter a valid tent number</span>
          )}
        </div>
        {/* Footer */}

        <Box
          sx={{
            p: 2,
            borderTop: "1px solid #f0f0f0",
            position: "sticky",
            bottom: 0,
            bgcolor: "#fff",
            boxShadow: "0px -2px 10px rgba(0,0,0,0.05)",
          }}
        >
          <Button
            fullWidth
            variant="contained"
            disableElevation
            onClick={() => {
              if (!tentno || !tentno.trim() || parseInt(tentno, 10) === 0) {
                setErrMsg(true);
                setOpenTent(true);
              } else {
                dispatch({
                  type: 'WEB_LOGIN',
                  payload: {
                    ...sessionReducer,
                    table_details: {},
                    tent_id: tentno.trim()
                  }
                });
                setOpenTent(false);
                setErrMsg(false);
              }
            }}
            style={{
              fontSize: "1.3rem",
              borderRadius: "8px",

              color:  "white"  || TEXT_COLOR,
              backgroundColor: primaryColor || BUTTON_COLOR,
              boxShadow: "none",
            }}
          >
            Continue
          </Button>
        </Box>
      </Drawer>
      )}
    </>
  );
};

export default TentPopup;
